module.exports = __webpack_public_path__ + "img/数据服务select.1f5436b6.svg";